import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { FormattedMessage } from 'react-intl'
import errorCatcher from '../../utils/errorCatcher'
import { RootState } from '../reducers'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { Grid } from '@material-ui/core'
import Dialog from '../../components/dialog/Dialog'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			dialogContainerLargeScreen: {
				padding: 35
			},
			dialogContainerSmallScreen: {
				padding: 10
			},
			message: {
				marginTop: 30
			}
		}
	)
)

// eslint-disable-next-line
const YFPopInEcDesactive: React.FC<{}> = ({}) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 770px)'
		}
	)

	const dialogClass: ClassValue = classNames(
		isLargeScreen ? classes.dialogContainerLargeScreen : classes.dialogContainerSmallScreen
	)

	const dialogTitle: ClassValue = classNames(
		classes.colorAccessibility,
		classes.title2
	)

	const dialogText: ClassValue = classNames(
		classes.message,
		classes.text1
	)

	const closePopIn = () => {

	}

	return (
		<Dialog
			onCloseDialog={closePopIn}
			open={true}
			fullScreen={!isLargeScreen}
			maxWidth="md"
			withPadding={false}
		>
			<Grid item container className={dialogClass}>
				<Grid item xs={12} className={dialogTitle}>
					<FormattedMessage
						id="popinEcDesactive.title"
						defaultMessage="Espace client désactivé"
						description="popinEcDesactive.title"
					/>
				</Grid>
				<Grid item xs={12} className={dialogText}>
					<FormattedMessage
						id="popinEcDesactive.text"
						defaultMessage="Chère madame, cher monsieur,
										L'accès à l'espace client est indisponible.
										Veuillez contacter le support pour obtenir de l'aide"
						description="popinEcDesactive.text"
						values={
							{
								br: <br />
							}
						}
					/>
				</Grid>
			</Grid>
		</Dialog>

	)
}

const mapStateToProps = (state: RootState) => (
	{}
)

const mapDispatchToProps = {
	errorCatcher
}

export default connect(mapStateToProps, mapDispatchToProps)(YFPopInEcDesactive)